/**
 * Utility functions to generate GCP and Firebase Console links
 */

/**
 * Get Firebase Console Firestore link for a project
 * @param projectId Optional project ID. If provided, link is project-scoped.
 * @returns Firebase Console Firestore URL
 */
export function getFirebaseConsoleFirestoreLink(projectId?: string): string {
  if (projectId) {
    return `https://console.firebase.google.com/project/${projectId}/firestore`;
  }
  return 'https://console.firebase.google.com/';
}

/**
 * Get Google Cloud Console API enablement link for Firestore Admin API
 * @param projectId Optional project ID. If provided, link is project-scoped.
 * @returns Google Cloud Console API library page URL for Firestore Admin API
 */
export function getGcpConsoleApiLink(projectId?: string): string {
  const baseUrl = 'https://console.cloud.google.com/apis/library/firestore.googleapis.com';
  if (projectId) {
    return `${baseUrl}?project=${projectId}`;
  }
  return baseUrl;
}

/**
 * Get Google Cloud Console IAM page link
 * @param projectId Optional project ID. If provided, link is project-scoped.
 * @returns Google Cloud Console IAM page URL
 */
export function getGcpConsoleIamLink(projectId?: string): string {
  const baseUrl = 'https://console.cloud.google.com/iam-admin/iam';
  if (projectId) {
    return `${baseUrl}?project=${projectId}`;
  }
  return baseUrl;
}
